import { Box, Typography } from '@material-ui/core';
import useLocales from 'hooks/useLocales';
import useAuth from '@hooks/useAuth';

interface CandidateAssessmentMetadataProps {
  candidate: any;
  item?: any;
  variant?: 'card' | 'graph';
}

export const CandidateAssessmentMetadata = ({
  candidate,
  item,
  variant = 'card'
}: CandidateAssessmentMetadataProps) => {
  const { t } = useLocales();
  const {
    isAdmin,
    isRecruiterPlus,
    isRecruiter,
    isHiringManager,
    isReviewer,
    isCandidate
  } = useAuth();

  const recruiterOrAdmin =
    isAdmin || isRecruiterPlus || isRecruiter || isHiringManager || isReviewer;

  // Get assessment metadata from candidate object (could be item.candidate or candidate)
  const completionTime =
    (candidate as any)?.completion_time_minutes ??
    (item?.candidate as any)?.completion_time_minutes ??
    (candidate as any)?.test_completion_time_minutes ??
    (item?.candidate as any)?.test_completion_time_minutes ??
    null;

  const socialDesirability =
    (candidate as any)?.social_desirability_score ??
    (item?.candidate as any)?.social_desirability_score ??
    (candidate as any)?.test_social_desirability_score ??
    (item?.candidate as any)?.test_social_desirability_score ??
    null;

  // Only show for recruiters, not candidates
  if (isCandidate || !recruiterOrAdmin) {
    return null;
  }

  // Only show if at least one value is not null
  if (completionTime == null && socialDesirability == null) {
    return null;
  }

  const textVariant = variant === 'card' ? 'body2' : 'body1';
  return (
    <Box
      display="flex"
      flexDirection="column"
      marginTop={variant === 'card' ? 2 : 0}
    >
      {socialDesirability != null && (
        <Box display="flex">
          <Typography variant={textVariant} fontWeight={600} color="#562C82">
            {`${t('Social Desirability Score')}:`}
          </Typography>
          &nbsp;
          <Typography variant={textVariant} fontWeight={600}>
            {socialDesirability}
          </Typography>
        </Box>
      )}
      {completionTime != null && (
        <Box display="flex">
          <Typography variant={textVariant} fontWeight={600} color="#562C82">
            {`${t('Completion Time')}:`}
          </Typography>
          &nbsp;
          <Typography variant={textVariant} fontWeight={600}>
            {completionTime} {t('minutes')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
